var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5835 3.14697L8.04739 7.6717C8.57082 8.0381 8.83253 8.2213 9.1172 8.29226C9.36866 8.35494 9.63166 8.35494 9.88312 8.29226C10.1678 8.2213 10.4295 8.0381 10.9529 7.6717L17.4168 3.14697M5.3835 13.4386H13.6168C14.947 13.4386 15.612 13.4386 16.1201 13.1798C16.5669 12.9521 16.9303 12.5888 17.158 12.1419C17.4168 11.6338 17.4168 10.9688 17.4168 9.63864V4.57197C17.4168 3.24185 17.4168 2.57679 17.158 2.06875C16.9303 1.62186 16.5669 1.25853 16.1201 1.03083C15.612 0.771973 14.947 0.771973 13.6168 0.771973H5.3835C4.05337 0.771973 3.38831 0.771973 2.88027 1.03083C2.43338 1.25853 2.07005 1.62186 1.84236 2.06875C1.5835 2.57679 1.5835 3.24185 1.5835 4.57197V9.63864C1.5835 10.9688 1.5835 11.6338 1.84236 12.1419C2.07005 12.5888 2.43338 12.9521 2.88027 13.1798C3.38831 13.4386 4.05337 13.4386 5.3835 13.4386Z",
    stroke: "#667085",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3c07591d0f908cc866f3f270bf13b1e2.svg";
export { ForwardRef as ReactComponent };